import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as royalties from '@webapp/sdk/royalties';
import { Action } from 'redux';
import {
  GetBalance,
  GetBalanceSuccess,
  GetBalanceError,
} from '../action-creators';
import { GET_BALANCE } from '../actions';

export const getBalanceEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, GetBalance>(GET_BALANCE),
    mergeMap(async (action) => {
      try {
        const balance = await royalties.getBalance(action.accountId);

        return new GetBalanceSuccess(balance, action.accountId);
      } catch (err) {
        return new GetBalanceError((err as Error).message);
      }
    })
  );
